export default "__VITE_ASSET__uyAkdBVx__"